// BDSJEA-345: parser de Server-Sent Events (WHATWG EventSource), puro y sin
// dependencias. Tolera lo que emite Spring (`event:log` / `data:texto`, sin
// espacio tras los dos puntos) y lo que emiten otros servidores (`event: log`).
//
// - Fin de línea: \n, \r\n o \r (un \r al final del chunk espera al siguiente
//   para no partir un \r\n en dos líneas).
// - Línea en blanco: despacha el evento acumulado (si tuvo al menos un data).
// - Varias líneas `data:` de un mismo evento se unen con "\n".
// - Comentarios (":...") y campos id/retry/desconocidos se ignoran.
// - Se quita UN solo espacio inicial del valor (como manda la especificación).
//
// DESVIACIÓN DELIBERADA de WHATWG: `flush()` (fin del stream) procesa la línea
// incompleta y DESPACHA el evento pendiente aunque no haya línea en blanco
// final. La especificación lo descartaría; acá se prefiere no perder un `done`
// si el servidor o un proxy cierran el stream sin el último "\n\n".
//
// Una línea de más de MAX_LONGITUD_LINEA caracteres sin fin de línea se
// descarta entera (protege la memoria ante un stream corrupto).

export const MAX_LONGITUD_LINEA = 1000000

const quitarEspacioInicial = valor =>
  valor.startsWith(" ") ? valor.slice(1) : valor

export const crearParserSse = onEvento => {
  let pendiente = "" // texto aún sin línea completa
  let escaneado = 0 // prefijo de `pendiente` ya recorrido sin hallar fin de línea
  let descartando = false // se está salteando una línea demasiado larga
  let inicio = true
  let evento = ""
  let datos = []

  const despachar = () => {
    if (datos.length > 0) {
      onEvento({ evento: evento.trim() || "message", data: datos.join("\n") })
    }
    evento = ""
    datos = []
  }

  const procesarLinea = linea => {
    if (descartando) {
      descartando = false // era el resto de una línea descartada
      return
    }
    if (linea === "") {
      despachar()
      return
    }
    if (linea.startsWith(":")) return
    const idx = linea.indexOf(":")
    const campo = idx === -1 ? linea : linea.slice(0, idx)
    const valor = idx === -1 ? "" : quitarEspacioInicial(linea.slice(idx + 1))
    if (campo === "event") evento = valor
    else if (campo === "data") datos.push(valor)
  }

  const consumir = (texto, final) => {
    let buffer = pendiente + texto
    if (inicio && buffer.length > 0) {
      if (buffer.charCodeAt(0) === 0xfeff) buffer = buffer.slice(1)
      inicio = false
    }
    let desde = 0
    let i = escaneado // no se vuelve a recorrer lo ya escaneado (evita O(n²))
    let cortadoEnCR = false
    for (; i < buffer.length; i++) {
      const c = buffer[i]
      if (c === "\n") {
        procesarLinea(buffer.slice(desde, i))
        desde = i + 1
      } else if (c === "\r") {
        if (i === buffer.length - 1 && !final) {
          cortadoEnCR = true // puede ser un \r\n partido entre chunks
          break
        }
        procesarLinea(buffer.slice(desde, i))
        if (buffer[i + 1] === "\n") i++
        desde = i + 1
      }
    }
    pendiente = buffer.slice(desde)
    escaneado = cortadoEnCR ? i - desde : pendiente.length
    if (pendiente.length > MAX_LONGITUD_LINEA) {
      pendiente = ""
      escaneado = 0
      descartando = true
    }
  }

  return {
    push: texto => consumir(texto || "", false),
    flush: () => {
      consumir("", true)
      if (pendiente !== "") {
        procesarLinea(pendiente)
        pendiente = ""
        escaneado = 0
      }
      despachar()
    },
  }
}
